import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import image16 from "../../image/home_about.jpg";

const WeAre = () => {
  return (
    <section className="w-full bg-slate-950 overflow-hidden relative">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 min-h-[38rem] lg:min-h-[42rem]">

        {/* Content Side */}
        <div className="lg:col-span-7 flex items-center py-16 px-6 sm:px-12 lg:px-12 xl:px-16 z-10">
          <div className="max-w-xl flex flex-col justify-center items-start space-y-6 text-left">

            {/* Header Tag & Title */}
            <div data-aos="fade-up" className="space-y-2">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-500/10 text-orange-400 border border-orange-500/20">
                <span className="w-1.5 h-1.5 rounded-full bg-orange-500"></span>
                Who We Are
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight leading-tight">
                PoloPipes: <span className="bg-gradient-to-r from-orange-400 to-amber-300 bg-clip-text text-transparent">Industry Leaders</span>
              </h2>
            </div>

            {/* Descriptive Prose Blocks */}
            <div data-aos="fade-up" data-aos-delay="100" className="space-y-4 text-slate-300 font-normal text-sm sm:text-base leading-relaxed">
              <p>
                PoloPipes is a pioneering manufacturer of high-quality plastic piping and water management solutions across India. With decades of industry expertise, we deliver innovative, durable, and sustainable products that meet and exceed global quality standards.
              </p>

              <div className="p-4 rounded-2xl bg-slate-900/80 border border-slate-800/80 backdrop-blur-sm relative overflow-hidden">
                <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-orange-500 to-amber-500"></div>
                <p className="italic text-slate-300 text-xs sm:text-sm pl-2">
                  "Our commitment to excellence, continuous innovation, and customer satisfaction has made us a trusted partner for residential, commercial, industrial, and agricultural applications nationwide."
                </p>
              </div>
            </div>

            {/* Action Trigger Button */}
            <div data-aos="fade-up" data-aos-delay="200" className="pt-2">
              <Link
                to="/about"
                className="group relative inline-flex items-center gap-3 px-6 py-3.5 rounded-xl bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 text-white font-bold text-sm shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 hover:-translate-y-0.5 transition-all duration-300 overflow-hidden"
              >
                <span>About PoloPipes</span>
                <BsArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>

          </div>
        </div>

        {/* Image Side (Visible on Mobile & Desktop) */}
        <div className="lg:col-span-5 relative min-h-[300px] lg:min-h-full w-full overflow-hidden">
          <img
            src={image16}
            alt="PoloPipes manufacturing facility operation"
            className="absolute inset-0 w-full h-full object-cover pointer-events-none select-none hover:scale-105 transition-transform duration-700"
          />
          {/* Dark Gradients for Smooth Text Blend */}
          <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-slate-950 via-slate-950/40 to-transparent z-10"></div>
        </div>

      </div>
    </section>
  );
};

export default WeAre;